import "./ProgressBar.scss";

import React from "react";

type ProgressProps = {
  /**
   * The current progress value.
   * If omitted, the progress bar will be in an indeterminate state.
   */
  value?: number;
  className?: string;
};

const Progress: React.FC<ProgressProps> = ({ value, className }) => {
  const isIndeterminate = value === undefined || value === null;

  const rootClasses = ["progress-root", className, isIndeterminate ? "indeterminate" : ""]
    .filter(Boolean)
    .join(" ");

  const indicatorStyle = !isIndeterminate
    ? { transform: `translateX(-${100 - (value || 0)}%)` }
    : {};

  return (
    <div className={rootClasses}>
      <div className="progress-indicator" style={indicatorStyle} />
    </div>
  );
};

export default Progress;
